import { BannerCard } from '~/components/BannerCard';
import { Slider } from '~/components/Slide';
import type { Banner } from '~/services/queries/banners/useBanners';
import { useCallback, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import { slideSettings } from './slide-settings';
import * as S from './styles';

type BannerListProps = {
  banners: Banner[];
  userId: string;
};

export const BannerList = ({ banners, userId }: BannerListProps) => {
  const [dragging, setDragging] = useState(false);
  const defaultSettings = slideSettings(banners.length);

  const handleBeforeChange = useCallback(() => {
    setDragging(true);
  }, [setDragging]);

  const handleAfterChange = useCallback(() => {
    setDragging(false);
  }, [setDragging]);

  if (!banners.length) return null;

  return (
    <S.Container>
      <Row>
        <Col>
          <Slider
            hasMoreThanOne={banners.length > 1}
            settings={{
              beforeChange: handleBeforeChange,
              afterChange: handleAfterChange,
              ...defaultSettings,
            }}
          >
            {banners.map(
              ({ id, external_link, internal_link, scrolls_to, file }) => (
                <BannerCard
                  key={id}
                  id={id}
                  userId={userId}
                  file={file}
                  external_link={external_link}
                  internal_link={internal_link}
                  scrolls_to={scrolls_to}
                  dragging={dragging}
                />
              )
            )}
          </Slider>
        </Col>
      </Row>
    </S.Container>
  );
};
